(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Handle cart item removal using Shopify Cart API
    const removeButtons = document.querySelectorAll('.cart-remove-item');
    
    removeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const line = this.getAttribute('data-line');
        const row = this.closest('tr.cart_item');
        
        if (!line) {
          console.error('No line number found');
          return;
        }
        
        // Show loading state
        if (row) {
          row.style.opacity = '0.5';
          row.style.pointerEvents = 'none';
        }
        
        // Use Shopify Cart API to remove item
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            line: parseInt(line, 10),
            quantity: 0
          })
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          // Update header cart count before reload
          const cartCountElements = document.querySelectorAll('.cart-count');
          if (data.item_count !== undefined) {
            cartCountElements.forEach(function(element) {
              if (data.item_count > 0) {
                element.textContent = data.item_count;
                element.style.display = '';
              } else {
                element.style.display = 'none';
              }
            });
          }
          
          // Also update header cart count using global function
          if (typeof updateHeaderCartCount === 'function') {
            updateHeaderCartCount(data.item_count);
          }
          
          // Also update any cart count elements with class enj-cartcount
          const enjCartCountElements = document.querySelectorAll('.enj-cartcount');
          if (data.item_count !== undefined) {
            enjCartCountElements.forEach(function(element) {
              element.textContent = data.item_count;
            });
          }
          
          // Reload the page to show updated cart
          window.location.reload();
        })
        .catch(function(error) {
          console.error('Error removing item:', error);
          // Fall back to direct navigation
          const removeUrl = button.getAttribute('href');
          if (removeUrl) {
            window.location.href = removeUrl;
          }
        });
      });
    });
    
    // Auto-update cart when quantity changes (on input for type-only)
    // Handle both desktop and mobile inputs
    const quantityInputs = document.querySelectorAll('input[name="updates[]"]');
    let updateTimeout;
    
    quantityInputs.forEach(function(input) {
      // Use 'input' event instead of 'change' for real-time updates as user types
      input.addEventListener('input', function() {
        const rawValue = this.value;
        const quantity = parseInt(rawValue, 10);
        const line = this.getAttribute('data-line');
        const row = this.closest('tr.cart_item');
        
        // Allow empty input while typing
        if (rawValue === '' || rawValue === '-') {
          return;
        }
        
        // Validate quantity
        if (isNaN(quantity) || quantity < 1) {
          // Don't update if invalid, but allow user to keep typing
          return;
        }
        
        if (!line) {
          console.error('No line number found for quantity update');
          return;
        }
        
        // Show loading state
        if (row) {
          row.style.opacity = '0.6';
          row.style.pointerEvents = 'none';
        }
        
        // Clear any pending updates
        clearTimeout(updateTimeout);
        
        // Update cart using Shopify Cart API with debounce
        updateTimeout = setTimeout(function() {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              line: parseInt(line, 10),
              quantity: quantity
            })
          })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(function(data) {
            // Update cart totals without page reload
            if (data) {
              // Helper function to format money as dollars
              function formatMoney(cents) {
                return '$' + (cents / 100).toFixed(2);
              }
              
              // Update line prices if items array exists (both desktop and mobile)
              if (data.items && Array.isArray(data.items)) {
                data.items.forEach(function(item, index) {
                  const linePriceElements = document.querySelectorAll('.line-price[data-line="' + (index + 1) + '"]');
                  linePriceElements.forEach(function(element) {
                    if (item.line_price !== undefined) {
                      element.textContent = formatMoney(item.line_price);
                    }
                  });
                });
              }
              
              // Update cart total
              const totalElement = document.getElementById('cart-total-amount');
              if (totalElement && data.total_price !== undefined) {
                totalElement.innerHTML = '<strong>' + formatMoney(data.total_price) + '</strong>';
              }
              
              // Update header cart count
              const cartCountElements = document.querySelectorAll('.cart-count');
              if (data.item_count !== undefined) {
                cartCountElements.forEach(function(element) {
                  if (data.item_count > 0) {
                    element.textContent = data.item_count;
                    element.style.display = '';
                  } else {
                    element.style.display = 'none';
                  }
                });
              }
              
              // Also update header cart count using global function
              if (typeof updateHeaderCartCount === 'function') {
                updateHeaderCartCount(data.item_count);
              }
              
              // Also update any cart count elements with class enj-cartcount (if theme uses it)
              const enjCartCountElements = document.querySelectorAll('.enj-cartcount');
              if (data.item_count !== undefined) {
                enjCartCountElements.forEach(function(element) {
                  element.textContent = data.item_count;
                });
              }
              
              // Restore row state
              if (row) {
                row.style.opacity = '1';
                row.style.pointerEvents = 'auto';
              }
            } else {
              // Fallback to reload if data structure is unexpected
              window.location.reload();
            }
          })
          .catch(function(error) {
            console.error('Error updating quantity:', error);
            // Restore row state on error
            if (row) {
              row.style.opacity = '1';
              row.style.pointerEvents = 'auto';
            }
            // Reload to get accurate state on error
            window.location.reload();
          });
        }, 500); // Increased delay to avoid rapid-fire updates while typing
      });
      
      // Also handle blur to ensure final value is saved
      input.addEventListener('blur', function() {
        const quantity = parseInt(this.value, 10);
        if (isNaN(quantity) || quantity < 1) {
          this.value = 1;
          // Trigger update with corrected value
          this.dispatchEvent(new Event('input'));
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
